import Grid from '@mui/material/Grid';
import PageTitle from 'src/components/PageTitle';
import MachineGroups from './MachineGroups';

function Dashboard() {
  return (
    <>
      <PageTitle />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MachineGroups />
        </Grid>
      </Grid>
    </>
  );
}

export default Dashboard;
